<div oui-dialog-title>
  Détail de la demande de purge
  <oui-button
    type="icon"
    oui-dialog-close>
    <oui-icon>close</oui-icon>
  </oui-button>
</div>

<oui-dialog-content [scroll]="true">
  <div class="dialog-content">
    <section class="execution-summary">
      <div>
        <span>Investisseur</span>
        <strong>#{{ execution.investorId }}</strong>
      </div>
      <div>
        <span>RequestId</span>
        <strong>{{ execution.executionId }}</strong>
      </div>
      <div>
        <span>Statut</span>
        <strong>{{ execution.status || 'Non renseigné' }}</strong>
      </div>
      <div>
        <span>Demandée le</span>
        <strong>{{ formatDate(execution.startedAtUtc) }}</strong>
      </div>
    </section>
  </div>
</oui-dialog-content>

<oui-dialog-actions>
  <oui-button
    type="text"
    oui-dialog-close
    >Fermer</oui-button
  >
</oui-dialog-actions>
